/* eslint-disable no-unused-vars */
import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Bell } from 'assets/icons/index';
import * as S from './ResponsiveAppBar.styled';
import { DropDownMenu, ToggleBtn } from 'components';
import { redirectToOldPlatformUrl } from 'utils';
import { AccountSettings, ManagePeyments, Logout } from 'assets/icons';
import {
  selectPb_email,
  selectPb_username,
  isAdminSelector,
  isPublisherRole,
} from 'store/selectors';
import { manageApps_action } from 'store/actions';
import logo from 'assets/images/appnext_header_logo.svg';
import { routes } from 'config';

const defaultTemplate = {
  pb_id: '',
  pb_email: '',
  pb_username: '',
  pb_number: 0,
  selected: true,
};

const pages = [
  {
    page: 'Dashboard',
    key: 'dashboard',
    name: 'dashboard',
    href: `${routes.list.find((route) => route.id === 'dashboard').url}`,
  },
  {
    page: 'Apps',
    key: 'manageApps',
    name: 'apps',
    href: `${routes.list.find((route) => route.id === 'manageApps').url}`,
  },
  {
    page: 'Reports',
    key: 'reports',
    name: 'reports',
    href: `${routes.list.find((route) => route.id === 'reports').url}`,
  },
  {
    page: 'Campaigns',
    key: 'campaign',
    name: 'Discovery',
    href: `${routes.list.find((route) => route.id === 'campaign').url}`,
  },
];

const getHrefToAccountSettings = () => {
  if (window.REACT_APP_ENV === 'production') {
    return redirectToOldPlatformUrl(`/Publisher/Settings.aspx`);
  } else {
    return '/account-settings';
  }
};

const actions = [
  {
    key: 'settings',
    value: 'account settings',
    icon: <AccountSettings />,
    href: getHrefToAccountSettings(),
  },
  {
    key: 'payments',
    value: 'manage payments',
    icon: <ManagePeyments />,
    // href: redirectToOldPlatformUrl(`/Publisher/Payments.aspx`),
    href: '/payments',
  },
  { key: 'logout', value: 'logout', icon: <Logout /> },
];

// const types = ['advertiser', 'publisher', 'admin'];

function setScrollPosition(page, pathname) {
  if (page !== 'Campaigns') return;

  // enable scroll to the current app on Manage Campaigns page
  if (
    pathname.startsWith('/Discovery/CampaignReports/') ||
    pathname.startsWith('/Discovery/Campaign/Edit/') ||
    pathname.startsWith('/Discovery/Campaign/Duplicate/')
  ) {
    const id = pathname.split('/').at(-1);
    if (id) localStorage.setItem('scrollId', id);
  }
}

const ResponsiveAppBar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isAdmin = useSelector(isAdminSelector);
  const isPublisher = useSelector(isPublisherRole);
  const currentPb_email = useSelector(selectPb_email);
  const currentPb_username = useSelector(selectPb_username);
  const isSamsungUser = useSelector((state) => state.auth.isSamsungUser);

  const handleNavMenuClick = (page) => {
    if (page === 'campaign' || page === 'manageApps' || page === 'reports') {
      const url = routes.list.find((route) => route.id === page).url;
      navigate(url);
      return;
    }
    // if (page === 'dashboard') {
    //   // if (window.REACT_APP_ENV === 'production') {
    //   //   const newUrl = redirectToOldPlatformUrl(`/Dashboard.aspx`);
    //   //   window.location.href = newUrl;
    //   //   return;
    //   // }
    //   // if (window.REACT_APP_ENV === 'qa') {
    //   //   const url = routes.list.find((route) => route.id === page).url;
    //   //   navigate(url);
    //   //   return;
    //   // }
    // }

    // if (page === 'campaign'
    //       // if (window.REACT_APP_ENV === 'production') {
    //       //   const newUrl = redirectToOldPlatformUrl(`/Discovery/Manage.aspx`);
    //       //   window.location.href = newUrl;
    //       //   return;
    //       // }
    //       // if (window.REACT_APP_ENV === 'qa') {
    //       //   const url = routes.list.find((route) => route.id === page).url;
    //       //   navigate(url);
    //       //   return;
    //       // }
    //     }

    // if (page === 'reports') {
    //   // if (window.REACT_APP_ENV === 'production') {
    //   //   const newUrl = redirectToOldPlatformUrl(`/Revenue/Reports.aspx`);
    //   //   window.location.href = newUrl;
    //   //   return;
    //   // }
    //   // if (window.REACT_APP_ENV === 'qa') {
    //   //   const url = routes.list.find((route) => route.id === page).url;
    //   //   navigate(url);
    //   //   return;
    //   // }
    // }
  };

  const watchIsActive = (name) => {
    const path = window.location.pathname;
    if (path === '/' && name === 'campaign') return true;
    return path.includes(name);
  };

  const dispatch = useDispatch();

  return (
    <S.Content>
      <S.InnerContent id='responsiveAppBar'>
        <img src={logo} alt='logo' />
        <S.Nav>
          {!isSamsungUser &&
            pages
              .filter((pageItem) => {
                if (isPublisher && pageItem.key === 'campaign') return false;
                if (!isAdmin && !isPublisher && pageItem.key === 'reports') return false;
                return true;
              })
              .map(({ page, key, name, href }) => (
                <S.ButtonWrap key={key}>
                  <S.Line isActive={watchIsActive(name)}></S.Line>
                  <S.CustomLink
                    to={href}
                    key={key}
                    onClick={() => setScrollPosition(page, pathname)}
                    //onClick={() => handleNavMenuClick(key)}
                  >
                    {page}
                  </S.CustomLink>
                </S.ButtonWrap>
              ))}
        </S.Nav>
        <S.EmailWrap>
          {/* <ToggleBtn
            lableOn='publisher'
            labelOff='advertiser'
            id='changeRole'
            isChecked={userRole}
            onChange={changeRole}
          /> */}
          {/* <Bell /> */}
          <S.DropDown>
            {isAdmin && (
              <DropDownMenu
                defaultValue={currentPb_email ?? defaultTemplate}
                variant={DropDownMenu.Variants.Input}
              />
            )}
            <DropDownMenu
              values={actions}
              defaultValue={currentPb_username ?? defaultTemplate.pb_username}
              variant={DropDownMenu.Variants.RoundBTNDefault}
            />
          </S.DropDown>
        </S.EmailWrap>
      </S.InnerContent>
    </S.Content>
  );
};
export default ResponsiveAppBar;
